/** @format */

import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Select from "react-select";
import { useCreateFetch } from "../../data/Queries";
import moment from "moment";
import {
  gymPlans,
  subsAddCreate,
  subsDraftOrderPost,
} from "../../data/ApiEndpoints";
import Loader from "../ui/Loader";
import { formatDate } from "../../utils/utilityfunc";

const CreateMemberShip = ({ userForm, userDetails, token, next }) => {
  const [plansOpt, setPlansOpt] = useState();
  const [prices, setPrices] = useState();
  const { mutateAsync: createOrder, isLoading: isLoadingLink } = useCreateFetch(
    {
      url: subsDraftOrderPost,
      key: subsDraftOrderPost,
      token,
    }
  );
  const { mutateAsync: createSubsAdd, isLoading: isLoadingSubsAdd } =
    useCreateFetch({
      url: subsAddCreate,
      token,
      key: subsAddCreate,
    });
  const { mutateAsync: getGyms, isLoading } = useCreateFetch({
    key: gymPlans,
    url: gymPlans,
    token,
  });

  const formik = useFormik({
    initialValues: {
      membershipType: undefined,
      selectPlan: undefined,
      subscriptionStartsFrom: "",
      subscriptionAmount: "",
      selectPrice: undefined,
      paymentMode: undefined,
      cashAmount: 0,
      onlineAmount: 0,
      // description: "",
    },
    validationSchema: Yup.object().shape({
      membershipType: Yup.object().required("This is required*"),
      selectPlan: Yup.object().required("This is required*"),
      subscriptionStartsFrom: Yup.string().required("This is required*"),
      subscriptionAmount: Yup.string().required("This is required*"),
      selectPrice: Yup.object().required("This is required"),
      paymentMode: Yup.object().required("This is required*"),
      cashAmount: Yup.number()
        .typeError("This is not valid.")
        .integer("This is not valid.")
        .when("paymentMode.value", {
          is: "cash/online",
          then: (schema) => schema.required("This is Required*"),
          otherwise: (schema) => schema.notRequired(),
        })
        .test("test", "Choose Cash Payment Mode.", function (value) {
          const parentContext = this.options.context;
          const total = parentContext.selectPrice?.value;
          return parseFloat(total) > parseFloat(value);
        }),
      onlineAmount: Yup.number()
        .typeError("This is not valid.")
        .integer("This is not valid.")
        .when("paymentMode.value", {
          is: "cash/online",
          then: (schema) => schema.required("This is Required*"),
          otherwise: (schema) => schema.notRequired(),
        }),
      // description: Yup.string().required("This is required*").max(500),
    }),
    onSubmit: async (values) => {
      const duration = Number(values?.selectPlan?.duration);
      const isCash = values?.paymentMode?.value === "cash";
      const start_date = `${formatDate(
        values?.subscriptionStartsFrom,
        "DD-MM-YYYY"
      )}`;

      const temp = {
        gym_id: userForm?.gym_id,
        user_id: userDetails?.uid,
        price: values?.selectPrice?.value,
        trx_id: values?.paymentMode?.value,
        trx_status: "done",
        tax_percentage: "0",
        tax_amount: "",
        type: "regular",
        order_status: "done",
        slot_id: "",
        addon: "",
        start_date: start_date,
        expire_date: moment(values?.subscriptionStartsFrom)
          .tz("Asia/Kolkata")
          .add(duration, "days")
          .format("DD-MM-YYYY"),
        coupon: "",
        plan_id: values?.selectPlan?.plan_uid,
        remark: "",
        event_id: "",
        order_id: "",
        session_id: "",
        is_goal: 0,
        is_partial: 0,
        isWhatsapp: true,
        partial_details: {
          cash_amount: values?.cashAmount,
          online_amount: values?.onlineAmount,
        },
        is_full: values?.paymentMode?.value === "cash/online" ? 0 : 1,
      };

      const body = {
        ...temp,
        req_body: temp,
      };

      const { status, message } = isCash
        ? await createSubsAdd(body)
        : await createOrder(body);
      if (status) {
        toast.success(message);
        formik?.setValues({
          membershipType: null,
          selectPlan: null,
          subscriptionStartsFrom: "",
          subscriptionAmount: "",
          selectPrice: null,
          paymentMode: null,
          cashAmount: 0,
          onlineAmount: 0,
          description: "",
        });
        next();
      } else {
        toast.error(message);
      }
    },
  });

  async function getPlans() {
    try {
      const body = { gym_id: userForm?.gym_id };
      const { data, status } = await getGyms(body);
      if (status && data) {
        const res = data.map((plan) => {
          return {
            ...plan,
            label: plan?.plan_name,
            value: plan?.plan_uid,
          };
        });
        setPlansOpt(res);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function setPlans() {
    try {
      const price_details = formik?.values?.selectPlan?.price_details;
      formik.setFieldValue("selectPrice", null);
      const prices = price_details
        ? price_details.map((detail) => {
            return {
              ...detail,
              label: detail?.plan_price,
              value: detail?.plan_price,
            };
          })
        : [];
      setPrices(prices);
    } catch (error) {
      console.log(error);
    }
  }

  function calcTax(value) {
    try {
      const n = Number(value);
      if (n === null || isNaN(n)) {
        throw new Error("Invalid input. Please provide a valid numeric value.");
      }
      const taxable_amount = n * 0.8474575;
      const sgst = taxable_amount * 0.09;
      const cgst = taxable_amount * 0.09;
      const total_amount = n;
      return {
        taxable_amount: taxable_amount.toFixed(2),
        sgst: sgst.toFixed(2),
        cgst: cgst.toFixed(2),
        total_amount: total_amount.toFixed(2),
      };
    } catch (error) {
      console.log(error);
      return {
        taxable_amount: "N/A",
        sgst: "N/A",
        cgst: "N/A",
        total_amount: "N/A",
      };
    }
  }

  useEffect(() => {
    getPlans();
  }, []);

  useEffect(() => {
    try {
      setPlans();
      formik?.setFieldValue(
        "subscriptionAmount",
        formik?.values?.selectPlan?.plan_price
      );
    } catch (error) {
      console.log(error);
    }
  }, [formik?.values?.selectPlan]);

  useEffect(() => {
    try {
      const cash = Number(
        formik?.values?.cashAmount ? formik?.values?.cashAmount : 0
      );
      const total = Number(formik?.values?.selectPrice?.value);
      const remainingAmount = total - cash;
      formik?.setFieldValue(
        "onlineAmount",
        isNaN(remainingAmount) ? 0 : remainingAmount
      );
    } catch (error) {
      console.log(error);
    }
  }, [formik?.values?.cashAmount]);

  return (
    <div className="timer-wrapper">
      {isLoading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="grid-k mt-5 grid-col-2-k gap-1-k">
            <div className="flex-k flex-col-k">
              <label>Membership Type*</label>{" "}
              <Select
                classNamePrefix={"input-k-select"}
                options={[{ label: "Regular/Goal Focus", value: "regular" }]}
                name="membershipType"
                value={formik.values.membershipType}
                onChange={(value) =>
                  formik.setFieldValue("membershipType", value)
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.membershipType && formik.errors.membershipType ? (
                <div className="error-message">
                  {formik.errors.membershipType}
                </div>
              ) : null}
            </div>
            <div className="flex-k flex-col-k">
              <label>Select Plan*</label>{" "}
              <Select
                classNamePrefix={"input-k-select"}
                name="selectPlan"
                options={plansOpt}
                value={formik.values.selectPlan}
                onChange={(value) => formik.setFieldValue("selectPlan", value)}
                onBlur={formik.handleBlur}
              />
              {formik.touched.selectPlan && formik.errors.selectPlan ? (
                <div className="error-message">{formik.errors.selectPlan}</div>
              ) : null}
            </div>
            <div className="flex-k flex-col-k">
              <label>Subscription Starts From*</label>{" "}
              <input
                type="date"
                className={"input-k"}
                name="subscriptionStartsFrom"
                value={formik.values.subscriptionStartsFrom}
                onChange={(e) =>
                  formik.setFieldValue("subscriptionStartsFrom", e.target.value)
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.subscriptionStartsFrom &&
              formik.errors.subscriptionStartsFrom ? (
                <div className="error-message">
                  {formik.errors.subscriptionStartsFrom}
                </div>
              ) : null}
            </div>
            <div className="flex-k flex-col-k">
              <label>Subscription Amount*</label>{" "}
              <input
                type="text"
                className={"input-k"}
                placeholder="Subscription Amount"
                name="subscriptionAmount"
                value={formik.values.subscriptionAmount}
                disabled
              />
              {formik.touched.subscriptionAmount &&
              formik.errors.subscriptionAmount ? (
                <div className="error-message">
                  {formik.errors.subscriptionAmount}
                </div>
              ) : null}
            </div>
            <div className="flex-k flex-col-k">
              <label>Select Price*</label>{" "}
              <Select
                classNamePrefix={"input-k-select"}
                name="selectPrice"
                options={prices}
                value={formik.values.selectPrice}
                onChange={(value) => formik.setFieldValue("selectPrice", value)}
                onBlur={formik.handleBlur}
              />
              {formik.touched.selectPrice && formik.errors.selectPrice ? (
                <div className="error-message">{formik.errors.selectPrice}</div>
              ) : null}
            </div>
            <div className="flex-k flex-col-k">
              <label>Payment Mode*</label>{" "}
              <Select
                classNamePrefix={"input-k-select"}
                name="paymentMode"
                options={[
                  { label: "Cash", value: "cash" },
                  { label: "Online", value: "online" },
                  { label: "Cash/Online", value: "cash/online" },
                ]}
                value={formik.values.paymentMode}
                onChange={(value) => formik.setFieldValue("paymentMode", value)}
                onBlur={formik.handleBlur}
              />
              {formik.touched.paymentMode && formik.errors.paymentMode ? (
                <div className="error-message">{formik.errors.paymentMode}</div>
              ) : null}
            </div>
            {formik?.values?.paymentMode?.value === "cash/online" && (
              <>
                <div className="flex-k flex-col-k">
                  <label>Cash*</label>{" "}
                  <input
                    type="text"
                    className={"input-k"}
                    placeholder="Cash Amount"
                    name="cashAmount"
                    value={formik.values.cashAmount}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.cashAmount && formik.errors.cashAmount ? (
                    <div className="error-message">
                      {formik.errors.cashAmount}
                    </div>
                  ) : null}
                </div>
                <div className="flex-k flex-col-k">
                  <label>Online Amount*</label>{" "}
                  <input
                    type="text"
                    className={"input-k"}
                    placeholder="Online Amount"
                    disabled
                    name="onlineAmount"
                    value={formik.values.onlineAmount}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.onlineAmount && formik.errors.onlineAmount ? (
                    <div className="error-message">
                      {formik.errors.onlineAmount}
                    </div>
                  ) : null}
                </div>
              </>
            )}

            {formik?.values?.selectPrice?.value ? (
              <div className="grid-span-2-k my-3">
                <table className="small-table-k">
                  <thead>
                    <tr className="dark-bg-k w-full-k">
                      <th className="border  p-1">Tax Type</th>
                      <th className="border  p-1">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="p-1 border ">Amount</td>
                      <td className="p-1 border ">
                        {formik?.values?.selectPrice?.value || 0}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-1 border ">Taxable Amount</td>
                      <td className="p-1 border ">
                        {
                          calcTax(
                            formik?.values?.selectPrice?.value
                              ? formik?.values?.selectPrice?.value
                              : null
                          ).taxable_amount
                        }
                      </td>
                    </tr>
                    <tr>
                      <td className="p-1 border ">SGST</td>
                      <td className="p-1 border ">
                        {
                          calcTax(
                            formik?.values?.selectPrice?.value
                              ? formik?.values?.selectPrice?.value
                              : null
                          ).sgst
                        }
                      </td>
                    </tr>
                    <tr>
                      <td className="p-1 border ">CGST</td>
                      <td className="p-1 border ">
                        {
                          calcTax(
                            formik?.values?.selectPrice?.value
                              ? formik?.values?.selectPrice?.value
                              : null
                          ).cgst
                        }
                      </td>
                    </tr>
                    <tr>
                      <td className="p-1 border ">Total Amount</td>
                      <td className="p-1 border ">
                        {formik?.values?.selectPrice?.value || 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
          <div className="flex-k my-4 items-end-k js-end-k">
            <button
              disabled={isLoadingLink || isLoadingSubsAdd}
              type="submit"
              className="btn-k btn-primary-k large"
            >
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CreateMemberShip;
